import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    channels: [],
    page: 1,
    page_size: 10,
    order_column: 'created_at',
    order_type: 'desc',
    dialog: false
  },

  mutations: {
    setChannels(state, payload) {
      state.channels = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    }
  },

  actions: {
    read({ commit, state }) {
      commit('setLoading', true)
      axios.admin
        .get('preapproved/channel', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type
          }
        })
        .then(r => {
          commit('setChannels', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    deleteChannel({ dispatch, commit }, id) {
      commit('setLoading', true)
      id = id
      .replace(/[/]/g, '&sol;')
      .replace(/&/g, '&amp;')
      .replace(/>/g, '&gt;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;')
      axios.admin.delete('preapproved/channel/' + id).then(() => {
        dispatch('read')
      })
    },
    insert({ commit, dispatch }, channel) {
      axios.admin
        .post('preapproved/channel', {
          id: channel.id,
          name: channel.title
        })
        .then(() => {
          commit('setDialog', false)
          dispatch('read')
        })
    },
    CSVexport() {
      axios.admin
        .get('preapproved/csv/download', {
          responseType: 'blob'
        })
        .then(r => {
          const url = window.URL.createObjectURL(new Blob([r.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            'preapproved_channels.csv'
          )
          document.body.appendChild(link)
          link.click()
        })
        .catch(e => {
          console.log(e)
        })
    }
  }
}
